import { getPortalState, SiteDomain } from './portalDomain'

export { SiteDomain } from './portalDomain'

const portalState = getPortalState(window.location.pathname)

export const currentDomain: null | SiteDomain = portalState.currentDomain
export const isUserappDomain = portalState.isUserappDomain
export const isAdminDomain = portalState.isAdminDomain
export const isPartnerDomain = portalState.isPartnerDomain
export const isSupportDomain = portalState.isSupportDomain
export const isPortalDomain = portalState.isPortalDomain
export const currentPortalAudience: null | string = portalState.currentPortalAudience

export const isLandingPage = (location: string) => location === '/dashboard'

export default currentDomain
